import React, { useEffect, useCallback, useState} from 'react';
import {connect} from 'react-redux';

const WIDTH = 30;
const LEFT_PADDING = 9;
const RollVisualizer = ({rollSteps, stepNumber, resolution}) => { 
    rollSteps = rollSteps / 2;
    stepNumber = (stepNumber / 2.0) % 16;
    let style = {
        left: stepNumber * (WIDTH + LEFT_PADDING),
        width: rollSteps * (WIDTH + LEFT_PADDING),
    };
    return (
        <div className="roll-visualizer" style={style}>
        </div>
    );
}

export default RollVisualizer;
